import $ from 'jquery';
import {refreshUtmFields} from './form-utils.js';

export function initPetitionInlineComponents(root = document) {
  root.querySelectorAll('[data-inline-petition]').forEach((component) => {
    if (component.dataset.inlinePetitionInitialized === 'true') {
      return;
    }

    component.dataset.inlinePetitionInitialized = 'true';

    component.querySelectorAll('[data-show-petition-below-the-fold]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const formWrapper = document.getElementById(trigger.dataset.showPetitionBelowTheFold);

        if (!formWrapper) {
          return;
        }

        trigger.hidden = true;

        const form = formWrapper.querySelector('form');
        if (form && !form.querySelector('input[name="aha"]')) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'aha';
          input.value = component.dataset.askHomeAddress;
          form.appendChild(input);
        }

        $(formWrapper).slideDown(1000);

        window.setTimeout(() => {
          formWrapper.classList.remove('unfold');
          refreshUtmFields(formWrapper);
        }, 2000);
      }, {once: true});
    });
  });
}
